import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import classNames from 'classnames';

// Components
import FeaturedTitlesCard from '../../components/FeaturedTitlesCard/FeaturedTitlesCard';
import { ChevronCircleIcon } from '../../components/Icons';

// Hooks
import { useSwimlane } from '../../components/Swimlane/useSwimlane/useSwimlane';

// Styles
import './FeaturedTitlesSwimlane.scss';

const FeaturedTitlesSwimlane = ({ title: heroTitle, featuredTitles }) => {
  const {
    scrollContainerRef,
    showPreviousButton,
    showNextButton,
    handleButtonClick,
  } = useSwimlane();

  const featuredTitlesCards = featuredTitles.map((featuredTitle) => (
    <li
      key={featuredTitle.id}
      className={classNames({
        'featured-titles-swimlane__slider-item': true,
        'featured-titles-swimlane__slider-item-grid':
          featuredTitles.length === 3,
      })}
    >
      <FeaturedTitlesCard
        id={featuredTitle.id}
        title={featuredTitle.title}
        description={featuredTitle.description}
        shortDescription={featuredTitle.shortDescription}
        item={featuredTitle}
        hasSwimlane={featuredTitles.length > 3}
      />
    </li>
  ));

  return (
    <section className="featured-titles-swimlane">
      <section className="featured-titles-swimlane__slider-container">
        <AnimatePresence>
          {featuredTitlesCards.length > 3 && showPreviousButton && (
            <motion.button
              initial={{ opacity: 0, x: -16, y: '-75%' }}
              animate={{ opacity: 1, x: -8, y: '-75%' }}
              exit={{ opacity: 0, x: -16, y: '-75%' }}
              transition={{ duration: 0.3, type: 'tween' }}
              onClick={() => handleButtonClick('previous')}
              className="featured-titles-swimlane__button"
              tabIndex={-1}
              aria-hidden={true}
              title="Previous"
            >
              <ChevronCircleIcon direction="left" />
            </motion.button>
          )}
        </AnimatePresence>
        <div className="featured-titles-swimlane__slider-container-crop">
          <ul
            ref={scrollContainerRef}
            className="featured-titles-swimlane__slider"
            aria-label={`${heroTitle} featured titles`}
          >
            {featuredTitlesCards}
          </ul>
        </div>
        <AnimatePresence>
          {featuredTitlesCards.length > 3 && showNextButton && (
            <motion.button
              initial={{ opacity: 0, x: 16, y: '-75%' }}
              animate={{ opacity: 1, x: 8, y: '-75%' }}
              exit={{ opacity: 0, x: 16, y: '-75%' }}
              transition={{ duration: 0.3, type: 'tween' }}
              onClick={() => handleButtonClick('next')}
              className="featured-titles-swimlane__button"
              tabIndex={-1}
              aria-hidden={true}
              title="Next"
            >
              <ChevronCircleIcon direction="right" />
            </motion.button>
          )}
        </AnimatePresence>
      </section>
    </section>
  );
};

export default FeaturedTitlesSwimlane;
